export default __webpack_public_path__ + "static/media/25_photo.c14f683c.jpeg";